<template>
  <div>
    <div class="container">
      <div class="youthIntro">
        <img src="@/assets/img/team/youth/partners.png" alt="partners"/>
      </div>
    </div>

    <!-- //리스트 -->
  </div>
</template>

<script>
export default {
  name: 'teamYouthPartners',
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
